import {Component, Inject, Input, OnInit} from '@angular/core';
import {
  APIPoliciesComponent,
  LeftpanelComponent,
  LoaderWithProgressComponent,
  OAuth2ToggleConfirmationComponent,
  ScheduleJobDialogComponent, ViewRawComponent
} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {error} from 'selenium-webdriver';
import {ListenerService} from '../listener.service';
import {SchedulerListenerService} from '../scheduler-listener.service';
import cronstrue from 'cronstrue';
import {KongService} from '../kong.service';
import {AccountInfoService} from '../user/account-info.service';
import {Observable, of} from "rxjs";
import {EndpointComponent} from "../manage-entities/manage-entities.component";
import {ShowJobLogsComponent} from "./show-job-logs/show-job-logs.component";

@Component({
  selector: 'app-manage-scheduled-jobs',
  templateUrl: './manage-scheduled-jobs.component.html',
  styleUrls: ['./manage-scheduled-jobs.component.scss']
})
export class ManageScheduledJobsComponent implements OnInit {

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() pkey = localStorage.getItem('partnerKey');
  @Input() apikey = localStorage.getItem('apikey');

  columns = ['Job', 'API', 'Trigger', 'Status', 'Created', 'Last Updated', 'History'];
  jobMappingToSort = ['',
    'job_name', 'executor_name', '', '', 'created_at', '', ''];

  constructor(public platform: LeftpanelComponent,
              public schedulerListenerInstance: SchedulerListenerService,
              public listener: ListenerService,
              public confpost: ConfService,
              public accountInfoService: AccountInfoService,
              public router: Router,
              public dialog: MatDialog) {
    listener.jobScheduled.subscribe(status => {
      if (status) {
        this.refreshScheduledJobs();
      }
    });
  }

  scheduledJobs: any;
  schedulerLogs: any;
  componentLoading = true;

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.getScheduledJobs();
  }

  toggleExecutor(ev, job) {
    $('.' + job['job_meta']['id']).slideToggle("fast","swing");
    $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
    this.getHistoryLogs(job);
  }

  openDialog(job): void {
    this.getHistoryLogs(job);
    const dialogRef = this.dialog.open(ShowJobLogsComponent, {
      width: '80%',
      height: '80%',
      data: job,
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  getTime(val) {
    if (typeof val === 'number') {
      return this.platform.timeConverter(val);
    } else {
      return val;
    }
  }

  getTrigger(trigger) {
    let triggerString = '';
    if (trigger) {
      if (trigger['type'] === 'date') {
        triggerString = 'Once at ';
        const startDateTime = trigger['configurations']['run_date'].split(' ');
        triggerString = triggerString + startDateTime[1] + ' on ' + startDateTime[0];
        return triggerString;
      } else if (trigger['type'] === 'interval') {
        const startDateTime = trigger['configurations']['start_date'].split(' ');
        const endDateTime = trigger['configurations']['end_date'].split(' ');
        if (trigger['configurations'].hasOwnProperty('seconds')) {
          triggerString = triggerString + 'Every second from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
        } else if (trigger['configurations'].hasOwnProperty('minutes')) {
          triggerString = triggerString + 'Every minute from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
        } else if (trigger['configurations'].hasOwnProperty('hours')) {
          triggerString = triggerString + 'Every hour from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
        } else if (trigger['configurations'].hasOwnProperty('days')) {
          triggerString = triggerString + 'Every day from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
        } else if (trigger['configurations'].hasOwnProperty('weeks')) {
          triggerString = triggerString + 'Every week from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
        }
        return triggerString;
      } else if (trigger['type'] === 'cron') {
        return cronstrue.toString(trigger['cron_expression'], {verbose: true});
      }
    }
  }
  getScheduledJobs() {
    this.componentLoading = true;
    if (this.scheduledJobs && this.scheduledJobs !== null && this.scheduledJobs !== undefined && this.scheduledJobs !== '') {
      this.componentLoading = false;
    }
    else {
      return new Promise((resolve, reject) => {
        this.confpost.getData('services', 'services', 'v1', 'scheduledJobs', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(response => {
          this.scheduledJobs = response;
          this.componentLoading = false;
          resolve('success');
        }, error => {
          this.platform.handleErrorGracefully(error, 'Error while retrieving scheduled jobs. Please try again after sometime.');
          reject(error);
          this.router.navigateByUrl('/controlplane');
        });
      });
    }

  }

  refreshScheduledJobs() {
    this.componentLoading = true;
    Promise.resolve(this.getScheduledJobs()).then(response => {
      this.componentLoading = false;
    }, error => {
      this.router.navigateByUrl('/controlplane');
    });
  }

  viewRaw(obj) {
    const rawDialog = this.dialog.open(ViewRawComponent, {
      width: '60%',
      data: {
        title: 'Raw Data',
        JSON: obj
      }
    });
  }

  // getHistoryCount(job) {
  //   if (this.schedulerLogs) {
  //     const logs = this.schedulerLogs.filter((log) => log['details']['job_id'] === job['job_meta']['id']);
  //     // job['history_logs'] = logs;
  //     return logs.length;
  //   }
  // }

  getHistoryLogs(job) {
      if (!job.hasOwnProperty('history_logs')) {
        this.confpost.getData('services', 'services', 'v1', 'schedulerLogs', 'event=EVENT_JOB_EXECUTED&details.job_id.in=' + job['job_meta']['id']).subscribe(response => {
          job['history_logs'] = response;
        }, error => {
          this.platform.handleErrorGracefully(error, 'Error while retrieving scheduler logs. Please try again after sometime.');
        });
      }
  }

  getMessage(responseObject) {
    if (responseObject['body'] && responseObject['body'][0] && responseObject['body'][0].hasOwnProperty('body')) {
      return responseObject['body'][0]['body'];
    } else {
      return '';
    }
  }

  statusToggle(event, job) {
    let statusToSend: string;
    console.log(job['status']);
    if (event.checked) {
      statusToSend = 'inactive';
    } else {
      statusToSend = 'active';
    }
    const confirmPrompt = this.dialog.open(ToggleJobStatusComponent, {
      width: '60%',
      disableClose: true,
      data: {
        jobName: job['job_name'],
        status: statusToSend,
      }
    });

    confirmPrompt.afterClosed().subscribe(response => {
      if (response) {
        if (response === 'pause') {
          this.pauseJob(job);
        } else if (response === 'resume') {
          this.resumeJob(job);
        } else {
          event.source.checked = !event.source.checked;
        }
      } else {
        event.source.checked = !event.source.checked;
      }
    });
  }

  editJob(job) {
    const configuration = {
      type: job['trigger']['type'],
      configurations: job['trigger']['configurations'],
    };
    if (job['trigger']['type'] === 'cron') {
      configuration['cron_expression'] = job['trigger']['cron_expression'];
    }
    const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
      width: '30vw',
      height: '80vh',
      data: {
        mode: 'edit',
        name: job['executors'][0]['executor_name'],
        version: job['executors'][0]['executor_version'],
        configuration: configuration,
        startDateActualFormat: job['trigger']['start_date_actual_format'],
        endDateActualFormat: job['trigger']['end_date_actual_format'],
        jobName: job['job_name'],
        jobDescription: job['description'],
        wholeData: job
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      this.refreshScheduledJobs();
    });
  }

  rescheduleJob(job) {
    const configuration = {
      type: job['trigger']['type'],
      configurations: job['trigger']['configurations'],
    };
    if (job['trigger']['type'] === 'cron') {
      configuration['cron_expression'] = job['trigger']['cron_expression'];
    }
    const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
      width: '30vw',
      height: '60vh',
      data: {
        mode: 'reschedule',
        name: job['executors'][0]['executor_name'],
        version: job['executors'][0]['executor_version'],
        configuration: configuration,
        startDateActualFormat: job['trigger']['start_date_actual_format'],
        endDateActualFormat: job['trigger']['end_date_actual_format'],
        jobName: job['job_name'],
        jobDescription: job['description'],
        wholeData: job
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      this.refreshScheduledJobs();
    });
  }

  resumeJob(job) {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_resume_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.schedulerListenerInstance.schedulerListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    this.confpost.resumeJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_resume_success', 'INFO', data.status, data.statusText, '', {partner: this.partner, account: this.account, id: job['job_meta']['id']}, data, this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.schedulerListenerInstance.schedulerListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      loaderDialog.close();
      this.platform.openSnackBar('Job resumed successfully.', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.refreshScheduledJobs();
    }, error1 => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_resume_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {partner: this.partner, account: this.account, id: job['job_meta']['id']}, error1, this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.schedulerListenerInstance.schedulerListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.platform.handleErrorGracefully(error1, 'Error while resuming the job. Please try again after sometime');
      loaderDialog.close();
    });
  }

  pauseJob(job) {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_pause_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.schedulerListenerInstance.schedulerListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    this.confpost.pauseJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_pause_success', 'INFO', data.status, data.statusText, '', {partner: this.partner, account: this.account, id: job['job_meta']['id']}, data, this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.schedulerListenerInstance.schedulerListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      loaderDialog.close();
      this.platform.openSnackBar('Job paused successfully.', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.refreshScheduledJobs();
    }, error1 => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_pause_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {partner: this.partner, account: this.account, id: job['job_meta']['id']}, error1, this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.schedulerListenerInstance.schedulerListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.platform.handleErrorGracefully(error1, 'Error while pausing the job. Please try again after sometime');
      loaderDialog.close();
    });
  }

  deleteJob(job) {
    if (confirm('The action is irreversible. Do you still want to delete the job?')) {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.schedulerListenerInstance.schedulerListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      this.confpost.deleteJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_delete_success', 'INFO', data.status, data.statusText, '', {partner: this.partner, account: this.account, id: job['job_meta']['id']}, data, this.router.url)).then(response => {
          const payloadToSend = {
            actions: response
          };
          this.schedulerListenerInstance.schedulerListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        loaderDialog.close();
        this.platform.openSnackBar('Job deleted successfully.', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.scheduledJobs = this.scheduledJobs.filter(item => item !== job);
        this.refreshScheduledJobs();
      }, error1 => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_delete_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {partner: this.partner, account: this.account, id: job['job_meta']['id']}, error1, this.router.url)).then(response => {
          const payloadToSend = {
            actions: response
          };
          this.schedulerListenerInstance.schedulerListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.platform.handleErrorGracefully(error1, 'Error while deleting the job. Please try again after sometime');
        loaderDialog.close();
      });
    }
  }

  createPaddingRight() {
    document.getElementById('view:scheduler').style.paddingRight = '400px';
  }

  removePaddingRight() {
    document.getElementById('view:scheduler').style.paddingRight = '0px';
  }
}

@Component({
  selector: 'app-toggle-job-status',
  templateUrl: 'toggle-job-status/toggle-job-status.component.html',
  styleUrls: ['toggle-job-status/toggle-job-status.component.css']
})
export class ToggleJobStatusComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ToggleJobStatusComponent>, public confPost: ConfService) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }
}
